import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import VideoRendering from '../common/VideoRendering/VideoRendering';
import { className } from '../../Utils';
import './Slider.css';

const Slider = ({ sliderData, photoFrame, videoUrl, intervalTime = 2000 }) => {
    const { language } = useSelector((state) => state.home);
    const [activeIndex, setActiveIndex] = useState(0);
    const vidRef = useRef(null);

    // Auto slide images
    useEffect(() => {
        if (videoUrl || !sliderData?.length) return;

        const interval = setInterval(() => {
            setActiveIndex((prevIndex) =>
                prevIndex === sliderData.length - 1 ? 0 : prevIndex + 1
            );
        }, intervalTime);

        return () => clearInterval(interval);
    }, [sliderData, videoUrl, intervalTime]);

    return (
        <div className={className('slider-wrapper')}>
            <div className={className('slider-container')}>
                <div className={className('section')}>
                    <img
                        src={photoFrame}
                        className={className(`section-phone-img-${language}`)}
                        alt="phone frame"
                    />
                    {videoUrl ? (
                        <div className={className('video-wrapper')}>
                            <VideoRendering
                                videoUrl={videoUrl}
                                cssStyles="slider-video"
                                vidRef={vidRef}
                            />
                        </div>
                    ) : (
                        sliderData?.map((slide, index) => {
                            const lastIndex = slide.url.lastIndexOf('.');
                            const type = slide.url.substr(lastIndex);

                            return (
                                <div
                                    key={slide.id}
                                    className={className(slide.id - 1 === activeIndex ? 'slides' : 'inactive') + ` active`}
                                >
                                    <div className={className('media-container')}>
                                        {type === '.mp4' ? (
                                            <div className={className('video-wrapper')}>
                                                <VideoRendering
                                                    videoUrl={videoUrl}
                                                    cssStyles="slider-video"
                                                    vidRef={vidRef}
                                                />
                                            </div>
                                        ) : (
                                            <img
                                                src={slide.url}
                                                className={className('slider-img') + ' ' + className(language !== 'bg' && 'slider-img-international')}
                                                alt='slider content'
                                            />
                                        )}
                                    </div>
                                </div>
                            )
                        })
                    )}
                </div>
            </div>
        </div>
    )
}

export default Slider;
